module.exports = __webpack_public_path__ + "img/logement-espace-exterieur-mini.ac99ec15.png";